<template>
    <s-top-bar v-if="ribbon" v-bind="{ ...ribbon }" />
</template>

<script>
import STopBar from './top-bar.vue';

export default {
    name: 'STopBarContainer',
    components: { STopBar },
    props: {
        ribbons: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            ribbon: null,
        };
    },
    mounted() {
        this.ribbon = this.ribbons[Math.floor(Math.random() * this.ribbons.length)];
    },
};
</script>
